import React from 'react';
import './App.scss';
import MainPage from './MainPage';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { amber, deepOrange, green, grey, purple } from '@mui/material/colors';
import { PaletteMode } from '@mui/material';
import ReactGA from 'react-ga4';

declare module '@mui/material/styles' {

  interface Palette {
    customBackground: Palette['primary'];
    iconInner: Palette['primary'];
    redCustom: Palette['primary'];
    greenCustom: Palette['primary'];
    orangeCustom: Palette['primary'];
  }

  interface PaletteOptions {
    customBackground: PaletteOptions['primary'];
    iconInner: PaletteOptions['primary'];
    redCustom: PaletteOptions['primary'];
    greenCustom: PaletteOptions['primary'];
    orangeCustom: PaletteOptions['primary'];
  }
}

const getDesignTokens = (mode: PaletteMode) => ({
  // Currently only dark mode is used
  palette: {
    mode,
    ...(mode === 'light'
      ? {
        // palette values for light mode
        primary: amber,
        divider: amber[200],
        text: {
          primary: grey[900],
          secondary: grey[800],
        },

        customBackground: {
          main: "#F0F0F0"
          // main: "#121212"

        },
        iconInner: {
          main: "#FFFFFF"
        },
        redCustom: {
          main: "#D14343"
        },
        greenCustom: {
          main: "#14B8A6"
        },
        orangeCustom: {
          main: "#FFB020"
        },
      }
      : {
        // palette values for dark mode
        primary: {
          main: "#65C18C"
        },

        // divider: deepOrange[700],
        background: {
          // default: "#1D1D1D",
          paper: "#1D1D1D",
        },
        text: {
          primary: '#fff',
          secondary: grey[500],
        },
        customBackground: {
          main: "#121212"
          // main: "#121212"

        },
        iconInner: {
          main: "#FFFFFF"
        },
        redCustom: {
          main: "#D14343"
        },
        greenCustom: {
          main: "#14B8A6"
        },
        orangeCustom: {
          main: "#FFB020"
        },

      }),
  },
});

// const TRACKING_ID = "G-J64X0J2FQ0"; // OUR_TRACKING_ID Testid

let TRACKING_ID = process.env.REACT_APP_TRACKING_ID
TRACKING_ID === undefined && (TRACKING_ID = "G-1234")
ReactGA.initialize(TRACKING_ID);

function App() {
  const [mode, setMode] = React.useState<PaletteMode>('dark');
  const colorMode = React.useMemo(
    () => ({
      // The dark mode switch would invoke this method
      toggleColorMode: () => {
        setMode((prevMode: PaletteMode) =>
          prevMode === 'light' ? 'dark' : 'light',
        );
      },
    }),
    [],
  );

  // Update the theme only if the mode changes
  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);


  return (
    <ThemeProvider theme={theme}>
      <MainPage />
    </ThemeProvider>
  );
}

export default App;
